import { Typography, useTheme } from "@mui/material";
import { AmountNotice } from "web_myplann/Goals/Components/AmountSections/AmountNotice";

type Props = {
	title: string;
	description: string;
};

export const WarningNotice: React.FC<Props> = ({ title, description }) => {
	const theme = useTheme();

	return (
		<AmountNotice tone="warning">
			<Typography variant="bodyStrong">{title}</Typography>
			<Typography variant="caption" color={theme.palette.grey[600]} tabular>
				{description}
			</Typography>
		</AmountNotice>
	);
};
